import { getSideMenuState } from './sidemenuState';

import colors from 'app/assets/colors';
import { _t } from 'app/utils/i18n';

type TColors<T = typeof defaultColors> = T & {
  [key: string]: string;
};
type TApp = {
  title?: string;
  navigations: any;
  logo: string;
  logoURl: string;
  defaultLanguage: {
    label?: string;
    value?: string;
  };
  defaultCountries: {
    label?: string;
    value?: string;
  }[];
  timezone: {
    label?: string;
    value?: string;
  };
  identifyTrendingCountries: {
    label?: string;
    value?: string;
  }[];
  faqs: {
    title: string;
    description: string;
    link_title: string;
    link: string;
    title_ar: string;
    description_ar: string;
    link_title_ar: string;
  }[];
  date_format: {
    label?: string;
    value?: string;
  };
  time_format: boolean;
  trending_duration: {
    label?: string;
    value?: string;
  };
};
interface ISettings {
  theme: {
    colors: TColors;
    app: TApp;
  };
  darkMode: boolean;
}

const defaultColors = {
  bodyColor: '#fafafa',
  mainColor: '#4f4f4f',
  secondaryColor: '#4151a6',
  borderColor: '#e5e5e5',
  bgColor: '#fff',
  negativeColor: '#ff1300',
  neutralColor: '#ffa700',
  positiveColor: '#9ea641',
  errorColor: '#ff1c00',
  lightGray: '#ACACAC',
  darkBlack: '#000',
  chartsColors: colors,
  darkBodyColor: '#121826',
  darkBorderColor: '#394150',
  darkMainColor: '#FFFFFF',
  darkBgColor: '#1B2334',
  lightErrorColor: '#ffffff99',
  darkErrorColor: '#12182699',
  lightTweetTextColor: '#000',
  darkTweetSubTitleColor: '#71767b',
  lightTweetSubTitleColor: '#8698a9',
  lightDisabledColor: '#00000061 ',
  darkDisabledColor: '#e1e1e161',
  lightDisabledDatePicker: '#eee',
  darkDisabledDatePicker: '#706f6f',
  darkSecondaryColor: '#4151a6',
  darkChartsColors: colors,
  lightInstagramColor: '#808080',
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const getSettings = (modules: any): ISettings => {
  const defaultAppSetting: TApp = {
    title: process.env.REACT_APP_TITLE_HEADER,
    navigations: getSideMenuState(modules),
    logo: '',
    logoURl: '',
    defaultLanguage: {
      label: process.env.REACT_APP_DEFAULT_LANGUAGE,
      value: process.env.REACT_APP_DEFAULT_LANGUAGE,
    },
    timezone: {
      label: 'Asia/Dubai',
      value: 'Asia/Dubai',
    },
    faqs: [
      {
        title: '',
        description: '',
        link_title: '',
        link: '',
        title_ar: '',
        description_ar: '',
        link_title_ar: '',
      },
    ],
    date_format: {
      label: 'd/M/y',
      value: 'd/M/y',
    },
    time_format: false,
    trending_duration: {
      label: _t('reports:weekly'),
      value: 'weekly',
    },
    defaultCountries: [],
    identifyTrendingCountries: [],
  };
  return {
    theme: {
      colors: defaultColors,
      app: defaultAppSetting,
    },
  } as any;
};
export { getSettings };
export type { ISettings };
